import i18next from "../../i18n";
import { currencyFormatter } from "../../utils";

/**
 * The supplier's key bidding conditions, shown inline under the supplier column header in the
 * shared award matrix ({@link AwardMatrix}) so they're always visible while comparing
 * (payment · term / lead time / delivery / validity) — no need to open the detail panel.
 */
export const bidConditions = (offer: any): string[] => {
  const parts: string[] = [];
  if (offer?.paymentMethod && offer?.paymentTerm) {
    parts.push(
      `${offer.paymentMethod} · ${offer.paymentTerm} ${i18next.t("analytics.days")}`
    );
  }
  if (offer?.leadTime) {
    parts.push(
      `${i18next.t("award.leadTime")}: ${offer.leadTime} ${i18next.t("analytics.days")}`
    );
  }
  const delivery =
    offer?.deliveryPlace === "BUYER"
      ? i18next.t("offer.deliveryCostBuyer")
      : offer?.deliveryPlace === "SELLER" && offer?.deliveryCost === 0
        ? i18next.t("offer.deliveryIncludedBuyer")
        : offer?.deliveryPlace === "SELLER" && offer?.deliveryCost > 0
          ? currencyFormatter(
              offer.deliveryCost,
              offer.deliveryCostCurrency || offer.currency
            )
          : null;
  if (delivery) {
    parts.push(`${i18next.t("award.deliveryCost")}: ${delivery}`);
  }
  if (offer?.pickupAddress) {
    parts.push(`${i18next.t("offer.pickupAddress")}: ${offer.pickupAddress}`);
  }
  if (offer?.offerValidity) {
    parts.push(`${i18next.t("award.offerValidity")}: ${offer.offerValidity}`);
  }
  return parts;
};
